import { ContractReportResponse } from "src/api-service";
import { AppError } from "../../../../app-store-error.types";

export interface ContractReportsState {
    report: ContractReportResponse | null;
    loading: boolean;
    error: AppError | null;
}

export const initialContractReportsState: ContractReportsState = {
    report: null,
    loading: false,
    error: null,
};
